export default {
	data() {
		return {
			moduleName: 'deviceProfiles',
			detailPageRouteName: 'deviceProfileDetail',
			entity: {
				name: null,
				codec_order: [],
				supported_id_device_types: [],
				protocol_order_linear_content: [],
				protocol_order_nonlinear_content: [],
				protocols: {},
				id_operator: this.$_loggedUser_selectedOperatorId
			},
			updateFields: [
				'name',
				'id_operator',
				'codec_order',
				'supported_id_device_types',
				'protocol_order_linear_content',
				'protocol_order_nonlinear_content',
				'protocols'
			],
		}
	},
	methods: {
		filterFormParams(params) {
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (this.updateFields.includes(key)) {
					allowed[key] = value
				}
			}.bind(this))
			return allowed
		},
		resetFields() {
			/*
			this.$refs['protocolformref'].validateProtocolFormRequiredFields()
			this.$refs['protocolformref'].$refs['nameref'].setTouched(false) */
		},
		processErrorMessage(error) {
			let errorMessage = null;
			// this.$refs['protocolformref'].validateProtocolFormRequiredFields()

			this._.forEach(error['validation_errors'], function (message) {
				errorMessage = message;
			}.bind(this))

			return error['error_message'] = errorMessage || error['error_message'];
		},
		_processDetailErrorMessage(error) {
			let deleteError = null
			this._.forEach(error['validation_errors'], function (errorMessage) {
				deleteError = errorMessage;
			}.bind(this))

			if (deleteError) {
				error['error_message'] = deleteError
			}

			return error['error_message']
		},
		openRoute(routerName) {
			this.$router.push({
				name: routerName
			})
		},
		getDependency() {
			this.setLoadingMessage();

			return this.entityService.getDependency().then((response) => {
				this.codecs = _.sortBy(response.codecs, [(x) => x.name.toLowerCase()]);
				this.protocols = _.sortBy(response.protocols, [(x) => x.name.toLowerCase()]);
				this.deviceTypes = _.sortBy(response.device_types, [(x) => x.name.toLowerCase()]);
				this.streamProfiles = _.sortBy(response.stream_profiles, [(x) => x.name.toLowerCase()]);

				this.emptyMessage();
			});
		},
		onAddProtocol(idProtocol) {
			this.entity['protocols'][idProtocol] = {
				adaptivity_order: [false],
				stream_profile_order: []
			}

			this.entity.protocols = {...this.entity.protocols};
		}
	},
	computed: {
		operatorIdComputed: {
			get() {
				return this.entity.id_operator
			},
			set(newValue) {
				this.entity.id_operator = newValue
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/deviceProfiles/mixins/deviceProfiles.js